import { CartStatusesEnum } from "@monorepo/types";
import { SvgIconProps } from "@mui/material";

import { serviceIconsColors, ServiceIconsSizeEnum } from "../ServiceIcons";
import StyledSvgIcon from "../StyledSvgIcon/StyledSvgIcon";

interface IProps {
  active: boolean;
  delayed?: boolean;
  statusId?: CartStatusesEnum;
  size?: ServiceIconsSizeEnum;
}

export const ElectricityIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.electricity.color} {...props} viewBox="0 0 18 21">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75365 8.88141C9.75365 11.3628 7.74117 13.3655 5.26953 13.3655C2.79788 13.3655 0.7854 11.3531 0.7854 8.88141C0.7854 7.60163 0.7854 5.53053 0.7854 5.26676C1.33248 5.26676 8.9428 5.26676 9.76342 5.26676C9.76342 5.9213 9.75365 7.69932 9.75365 8.88141Z"
      stroke={serviceIconsColors.electricity.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M3.48169 1.20271V5.23745"
      stroke={serviceIconsColors.electricity.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M7.0769 1.20271V5.23745"
      stroke={serviceIconsColors.electricity.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12.3523 14.6649C12.3523 14.6649 12.3523 14.1178 12.3523 12.1639C12.3523 10.21 13.8861 8.67626 15.8009 8.63718C15.8302 8.63718 17.1783 8.63718 17.1783 8.63718"
      stroke={serviceIconsColors.electricity.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12.3523 14.1178V15.9251C12.3425 17.8692 10.7599 19.4518 8.81579 19.4518C6.8717 19.4518 5.32814 17.918 5.28906 16.0033C5.28906 15.9739 5.28906 13.3753 5.28906 13.3753"
      stroke={serviceIconsColors.electricity.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </StyledSvgIcon>
);

export const GasIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.gas.color} {...props} viewBox="4 0 16 18">
    <g filter="url(#filter0Dd445136)">
      <path
        d="M13.8415 0.886567C13.8415 0.886567 14.2225 3.15305 15.7563 5.273C17.2998 7.38318 18.2377 8.17449 18.3842 10.9001C18.5308 13.6258 15.9126 17.045 12.3272 17.1134C8.74189 17.1818 6.3484 15.1205 5.70363 11.7794C5.05885 8.43826 7.47188 5.6247 7.47188 5.6247C7.47188 5.6247 8.08734 7.1194 9.18151 8.32103C11.0475 2.36174 13.8415 0.886567 13.8415 0.886567Z"
        stroke={serviceIconsColors.gas.stroke}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15.258 10.2749C15.258 10.2749 15.4338 11.5058 14.5741 12.6391C13.7144 13.7626 12.5323 13.8212 12.5323 13.8212"
        stroke={serviceIconsColors.gas.stroke}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>
  </StyledSvgIcon>
);

export const WaterIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.water.color} {...props} viewBox="0 0 16 18">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.94629 0.847488C10.1932 4.01275 14.7946 5.66377 14.7946 10.2944C14.7946 14.9251 10.711 17.1427 7.88767 17.1427C5.06433 17.1427 1.19568 14.8958 1.19568 10.2651C1.19568 5.63446 5.74819 3.9346 7.93652 0.847488H7.94629Z"
      stroke={serviceIconsColors.water.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5.41602 11.1346C5.41602 11.1346 5.60163 11.8868 6.29526 12.4046C6.94003 12.8833 7.89743 12.981 7.89743 12.981"
      stroke={serviceIconsColors.water.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </StyledSvgIcon>
);

export const HeatIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.heat.color} {...props} viewBox="0 0 20 18">
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.19567 13.0494H1.29065"
        stroke={serviceIconsColors.heat.stroke}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.23475 4.22768H1.27112"
        stroke={serviceIconsColors.heat.stroke}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7289 13.0494H16.8336"
        stroke={serviceIconsColors.heat.stroke}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7289 4.22768H16.7555"
        stroke={serviceIconsColors.heat.stroke}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6285 14.505V3.48521C16.6285 2.18589 15.6418 1.1308 14.4206 1.1308C13.1995 1.1308 12.2128 2.18589 12.2128 3.48521V14.505C12.2128 15.8043 13.1995 16.8594 14.4206 16.8594C15.6418 16.8594 16.6285 15.8043 16.6285 14.505Z"
        stroke={serviceIconsColors.heat.stroke}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2127 14.505V3.48521C12.2127 2.18589 11.226 1.1308 10.0049 1.1308C8.7837 1.1308 7.797 2.18589 7.797 3.48521V14.505C7.797 15.8043 8.7837 16.8594 10.0049 16.8594C11.226 16.8594 12.2127 15.8043 12.2127 14.505Z"
        stroke={serviceIconsColors.heat.stroke}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.58922 16.8594C4.36805 16.8594 3.38135 15.8043 3.38135 14.505V3.48521C3.38135 2.18589 4.36805 1.1308 5.58922 1.1308C6.81038 1.1308 7.79709 2.18589 7.79709 3.48521V14.505C7.79709 15.8043 6.81038 16.8594 5.58922 16.8594Z"
        stroke={serviceIconsColors.heat.stroke}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledSvgIcon>
);

export const TelecommunicationIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.telecommunications.color} {...props} viewBox="0 0 20 14">
    <path
      d="M7.34766 10.3167C8.04128 9.62306 8.89121 9.01736 9.95607 9.01736C11.0209 9.01736 11.9197 9.71099 12.5743 10.3948"
      stroke={serviceIconsColors.telecommunications.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M9.96584 13.1987C10.1763 13.1987 10.3468 13.0281 10.3468 12.8176C10.3468 12.6072 10.1763 12.4366 9.96584 12.4366C9.75542 12.4366 9.58484 12.6072 9.58484 12.8176C9.58484 13.0281 9.75542 13.1987 9.96584 13.1987Z"
      fill={serviceIconsColors.telecommunications.stroke}
      stroke={serviceIconsColors.telecommunications.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.29968 7.26866C5.74554 5.81303 7.74826 4.90448 9.95613 4.90448C12.164 4.90448 14.2156 5.83257 15.6712 7.31751"
      stroke={serviceIconsColors.telecommunications.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M1.51538 4.46486C3.62556 2.20815 6.63451 0.801361 9.96586 0.801361C13.2972 0.801361 16.3745 2.24722 18.4945 4.55279"
      stroke={serviceIconsColors.telecommunications.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </StyledSvgIcon>
);

export const FinancialIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.financialServices.color} {...props} viewBox="0 0 22 16">
    <path
      d="M20.4519 6.16825V2.33867C20.4519 1.64505 19.8853 1.07843 19.1916 1.07843H2.81823C2.1246 1.07843 1.55798 1.64505 1.55798 2.33867V6.16825"
      fill="#00000000"
      stroke={serviceIconsColors.financialServices.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4519 7.48713V5.60164C20.4519 4.90802 19.8853 4.3414 19.1916 4.3414H2.81823C2.1246 4.3414 1.55798 4.90802 1.55798 5.60164V7.51643"
      fill="#00000000"
      stroke={serviceIconsColors.financialServices.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4519 7.50665H13.8283C13.8283 7.50665 13.203 9.47029 11.0245 9.47029C8.84592 9.47029 8.16206 7.50665 8.16206 7.50665H1.53845V13.6613C1.53845 14.355 2.11484 14.9216 2.80847 14.9216H19.1721C19.8657 14.9216 20.4323 14.355 20.4323 13.6613V7.50665H20.4519Z"
      fill="#00000000"
      stroke={serviceIconsColors.financialServices.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StyledSvgIcon>
);

export const HouseCareIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.houseCare.color} {...props} viewBox="0 0 18 18">
    <path
      d="M14.2607 6.59539V17.117H3.73914V6.58562"
      stroke={serviceIconsColors.houseCare.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M16.6347 7.45508C12.4534 5.6673 8.99509 0.929169 8.99509 0.929169C8.99509 0.929169 5.51721 5.6673 1.35547 7.45508"
      stroke={serviceIconsColors.houseCare.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </StyledSvgIcon>
);

export const EducationIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.education.color} {...props} viewBox="0 0 23 18">
    <path
      d="M4.44348 6.92755V14.4206C4.44348 14.4206 7.69667 16.5406 11.8193 16.5406C15.942 16.5406 18.7556 14.4304 18.7556 14.4304V6.98617"
      stroke={serviceIconsColors.education.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M0.975342 5.21791L10.647 1.15387C11.1355 0.948711 11.6923 0.948711 12.1808 1.15387L22.2139 5.24722L12.1905 9.30149C11.7021 9.49688 11.1452 9.49688 10.6568 9.30149L0.975342 5.24722V5.21791Z"
      stroke={serviceIconsColors.education.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M22.3213 5.30585V10.5422"
      stroke={serviceIconsColors.education.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </StyledSvgIcon>
);

export const SecurityIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.security.color} {...props} viewBox="0 0 16 18">
    <path
      d="M12.1862 15.0619C12.1862 15.2084 12.1666 15.3647 12.1373 15.5015C11.9322 16.4491 11.092 17.1525 10.0955 17.1525C8.94274 17.1525 8.00488 16.2147 8.00488 15.0619V7.9498"
      stroke={serviceIconsColors.security.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3221 7.95958C15.3221 4.03231 12.0396 0.847504 7.99509 0.847504C3.95059 0.847504 0.668091 4.03231 0.668091 7.95958H15.3221Z"
      stroke={serviceIconsColors.security.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </StyledSvgIcon>
);

export const DirectPaymentIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.directPayment.color} {...props} viewBox="0 0 22 20">
    <path
      d="M12.3335 5.384H6.14955V1.12457L1.12811 7.46487C0.932721 7.7091 0.932721 8.0608 1.12811 8.3148L6.14955 14.5574V9.90721H9.43204"
      stroke={serviceIconsColors.directPayment.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12.5582 9.89745H15.87V5.18863L20.8719 11.6071C21.0673 11.8513 21.0673 12.1932 20.8719 12.4375L15.87 18.8559V14.5379H9.70557"
      stroke={serviceIconsColors.directPayment.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </StyledSvgIcon>
);

export const FishingIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.fishing.color} {...props} viewBox="0 0 12 18">
    <path
      d="M3.12292 5.61493V13.0787C3.12292 15.3452 4.95956 17.1818 7.22605 17.1818C9.49253 17.1818 11.3292 15.3452 11.3292 13.0787V8.38942L9.52184 10.695"
      stroke={serviceIconsColors.fishing.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M3.09357 5.65399C4.42625 5.65399 5.50659 4.57364 5.50659 3.24097C5.50659 1.90829 4.42625 0.827942 3.09357 0.827942C1.76089 0.827942 0.680542 1.90829 0.680542 3.24097C0.680542 4.57364 1.76089 5.65399 3.09357 5.65399Z"
      stroke={serviceIconsColors.fishing.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </StyledSvgIcon>
);

export const InvoicesIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.invoices.color} {...props} viewBox="0 0 20 20">
    <path
      d="M10.0049 19.2857V0.723999"
      stroke={serviceIconsColors.invoices.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M0.723999 10.0049H19.2857"
      stroke={serviceIconsColors.invoices.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12.457 14.2545H18.0451"
      stroke={serviceIconsColors.invoices.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M1.96472 4.86621H7.55278"
      stroke={serviceIconsColors.invoices.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12.457 16.7066H18.0451"
      stroke={serviceIconsColors.invoices.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M3.0979 13.1897L7.05448 17.1463"
      stroke={serviceIconsColors.invoices.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M3.0979 17.1463L7.05448 13.1897"
      stroke={serviceIconsColors.invoices.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M15.4757 2.07214V7.6602"
      stroke={serviceIconsColors.invoices.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12.6816 4.86615H18.2697"
      stroke={serviceIconsColors.invoices.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </StyledSvgIcon>
);

export const GarbageIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.garbage.color} {...props} viewBox="0 0 18 18">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.672 17.0939H6.28907C4.60874 17.0939 3.25081 15.7262 3.25081 14.0361L2.73303 3.96391H15.3159L14.7005 14.0361C14.7005 15.7262 13.3425 17.0939 11.6622 17.0939H11.672Z"
      stroke={serviceIconsColors.garbage.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M1.26758 3.96392L16.7324 3.95415"
      stroke={serviceIconsColors.garbage.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M6.67004 14.3585V6.37694"
      stroke={serviceIconsColors.garbage.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M11.33 14.3585V6.37694"
      stroke={serviceIconsColors.garbage.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5.20459 3.96391C5.20459 3.96391 5.92752 2.03935 6.08383 1.68766C6.24014 1.33596 6.77745 0.906113 7.56877 0.906113H10.4898C11.2323 0.906113 11.7989 1.34573 11.9552 1.68766C12.1115 2.02959 12.7856 3.93461 12.7856 3.93461"
      stroke={serviceIconsColors.garbage.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </StyledSvgIcon>
);

export const OtherIcon = (props: SvgIconProps & IProps) => (
  <StyledSvgIcon activeColor={serviceIconsColors.other.color} {...props} viewBox="0 0 22 18">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.864258 6.02526L10.8192 1.22852L21.1356 6.0448L10.8387 10.8122L0.864258 6.02526Z"
      stroke={serviceIconsColors.other.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M2.62268 9.70831L10.9071 13.704L19.3771 9.70831"
      stroke={serviceIconsColors.other.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M2.62268 12.7759L10.9071 16.7715L19.3771 12.7759"
      stroke={serviceIconsColors.other.stroke}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </StyledSvgIcon>
);
